import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://uxckqsjgiegwocpcxany.supabase.co";
const supabaseAnonKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InV4Y2txc2pnaWVnd29jcGN4YW55Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjI2MTg2NzMsImV4cCI6MjA3ODE5NDY3M30.-Sq4WOAyq5TERN0dlNq-Zlr3qDPUn1cCgXE2BrcsAYY";

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    storage: window.localStorage,
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});
